
export enum VehicleCondition {
  Rollable= 'Rollable',
  Running= 'Running',
  Blocked= 'Blocked',

}